import {
  Flex,
  Heading,
  IconButton,
  Spacer,
  useColorMode,
  VStack,
} from '@chakra-ui/react'
import {
  FaSun,
  FaMoon,
  FaGithub,
  FaLinkedin,
  FaInstagram,
} from 'react-icons/fa'
import Header from './components/Header'
import Projects from './components/Projects'
import Social from './components/Social'
import Resume from './components/Resume'
import { Footer } from './components/Footer'
function App() {
  const { colorMode, toggleColorMode } = useColorMode()
  const isDark = colorMode === 'dark'
  return (
    <VStack p={5}>
      <Flex w='100%'>
        <Heading fontWeight='bold' color='cyan.400'>
          <Resume />
        </Heading>
        <Spacer />

        <IconButton
          ml={2}
          isRound='true'
          icon={<FaLinkedin />}
          onClick={() => window.open('https://linkedin.com/in/sharmaketann')}
        ></IconButton>

        <IconButton
          ml={2}
          icon={<FaInstagram />}
          isRound='true'
          onClick={() =>
            window.open('https://www.instagram.com/axxidently_happy/')
          }
        ></IconButton>
        <IconButton
          ml={2}
          icon={<FaGithub />}
          isRound='true'
          onClick={() => window.open('https://www.github.com/Sharmaketann')}
        ></IconButton>
        <IconButton
          ml={8}
          icon={isDark ? <FaSun /> : <FaMoon />}
          isRound='true'
          onClick={toggleColorMode}
        ></IconButton>
      </Flex>
      <Header></Header>
      <Social></Social>
      <Projects />
      <Resume />
      <Footer />
    </VStack>
  )
}

export default App
